import { FILE_SIZE } from '@shared/constants/fileSize';
import { FILE_TYPES } from '@shared/constants/fileTypes';
import FileValidator from '@shared/validators/FileValidator';
import Joi from 'joi';
import { OBSERVATION_REPORT_FIELD_NAMES, OBSERVATION_REPORT_DOCUMENTS_STATUS } from '../constants';

const MAX_FILE_SIZE = 5 * FILE_SIZE.MB;
const TYPE_ERROR_MESSAGE = 'Observation Report must be an Excel file.';
const COMMENT_ERROR_MESSAGE = 'Comment field is required. Must be a minimum of 25 characters.';
const REQUIRED_FIELD_ERROR_MESSAGE = 'Please complete all required fields.';
const COMMENT_MAX_LENGTH = 1000;
const COMMENT_MIN_LENGTH = 25;

const OBSERVATION_REPORT_SCHEMA = Joi.object({
  file: Joi.object().required()
});

const OBSERVATION_REPORT_REVIEW_SCHEMA = Joi.object({
  comment: Joi.when(OBSERVATION_REPORT_FIELD_NAMES.STATUS, {
    is: Joi.number().valid(
      OBSERVATION_REPORT_DOCUMENTS_STATUS.ACCEPTED,
      OBSERVATION_REPORT_DOCUMENTS_STATUS.RETURNED
    ),
    then: Joi.string().min(COMMENT_MIN_LENGTH).max(COMMENT_MAX_LENGTH).required().messages({
      '*': COMMENT_ERROR_MESSAGE
    })
  }),
  result: Joi.when(OBSERVATION_REPORT_FIELD_NAMES.STATUS, {
    is: OBSERVATION_REPORT_DOCUMENTS_STATUS.ACCEPTED,
    then: Joi.number().required().messages({
      '*': REQUIRED_FIELD_ERROR_MESSAGE
    }),
    otherwise: Joi.number().allow(null)
  })
}).unknown(true);

export const ObservationReportValidator = {
  reviewSchema: OBSERVATION_REPORT_REVIEW_SCHEMA,
  addSchema: OBSERVATION_REPORT_SCHEMA,
  fileSchema: FileValidator.createFileSchema(
    [FILE_TYPES.XLS, FILE_TYPES.XLSX],
    MAX_FILE_SIZE,
    TYPE_ERROR_MESSAGE
  ),
  validateReviewSchema: input => {
    return OBSERVATION_REPORT_REVIEW_SCHEMA.validate(input, { abortEarly: true });
  }
};
